import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "order-id"
}
const _hoisted_3 = {
  key: 1,
  class: "order-id"
}
const _hoisted_4 = { class: "order-last-time" }
const _hoisted_5 = { class: "amount-unit" }
const _hoisted_6 = { class: "amount" }
const _hoisted_7 = { class: "order-content" }
const _hoisted_8 = { key: 3 }

import { ref, PropType, computed } from 'vue';
import { Row, Col } from 'ant-design-vue';
import InPayment from './InPayment.vue';
import Paid from './Paid.vue';
import Unpaid from './Unpaid.vue';
import Countdown from '../widget/Countdown.vue';
import { ORDER_PAGE_STATUS, CHANNEL, OrderInfo } from '../utils/config';


export default /*@__PURE__*/_defineComponent({
  __name: 'Desktop',
  props: {
  orderData: {
    type: (Object as PropType<OrderInfo>) || undefined,
    required: true,
  },
  timeText: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const showOrderNo = computed(() => {
  return props.orderData?.orderNo && props.orderData.orderNo !== 'null';
});
const orderStatus = ref<ORDER_PAGE_STATUS>(ORDER_PAGE_STATUS.UNPAID);
const isTimeout = ref<boolean>(false);
const currentChannel = ref<CHANNEL>(CHANNEL.WECHAT);
const qrcodeUrl = ref<string>('');

// 切换页面的事件
const changePaymentStatus = (status: ORDER_PAGE_STATUS, channel?: CHANNEL, codeUrl?: string) => {
  orderStatus.value = status;
  channel ? (currentChannel.value = channel) : null;
  codeUrl ? (qrcodeUrl.value = codeUrl) : null;
};

// 订单超时状态，切换全局状态
const changeTimeoutStatus = (status: boolean) => {
  isTimeout.value = status;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (orderStatus.value !== _unref(ORDER_PAGE_STATUS).PAID)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Row), {
            justify: "space-between",
            class: "order-info"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Col), null, {
                default: _withCtx(() => [
                  (showOrderNo.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, "订单号：" + _toDisplayString(__props.orderData?.orderNo), 1))
                    : (__props.orderData?.contractNo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 签约号：" + _toDisplayString(__props.orderData?.contractNo), 1))
                      : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[0] || (_cache[0] = _createTextVNode(" 请在")),
                    _createVNode(Countdown, {
                      class: "time",
                      orderData: __props.orderData,
                      fontSize: 20,
                      timeText: __props.timeText,
                      lastTime: __props.orderData?.timeleft,
                      currentTime: __props.orderData?.currentTime,
                      changeTimeoutStatus: changeTimeoutStatus,
                      changePaymentStatus: changePaymentStatus
                    }, null, 8, ["orderData", "timeText", "lastTime", "currentTime"]),
                    _cache[1] || (_cache[1] = _createTextVNode(" 内完成支付，否则订单会自动取消！ "))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(Col), { class: "amount-text" }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createTextVNode(" 应支付： ")),
                  _createElementVNode("span", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(__props.orderData?.price), 1),
                    _cache[2] || (_cache[2] = _createElementVNode("span", null, "元", -1))
                  ])
                ]),
                _: 1,
                __: [3]
              })
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "hr" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (orderStatus.value === _unref(ORDER_PAGE_STATUS).UNPAID)
        ? (_openBlock(), _createBlock(Unpaid, {
            key: 0,
            orderData: __props.orderData,
            changePaymentStatus: changePaymentStatus
          }, null, 8, ["orderData"]))
        : (orderStatus.value === _unref(ORDER_PAGE_STATUS).INPAYMENT)
          ? (_openBlock(), _createBlock(InPayment, {
              key: 1,
              orderData: __props.orderData,
              isTimeout: isTimeout.value,
              currentChannel: currentChannel.value,
              changePaymentStatus: changePaymentStatus
            }, null, 8, ["orderData", "isTimeout", "currentChannel"]))
          : (orderStatus.value === _unref(ORDER_PAGE_STATUS).PAID)
            ? (_openBlock(), _createBlock(Paid, {
                key: 2,
                orderData: __props.orderData,
                changePaymentStatus: changePaymentStatus
              }, null, 8, ["orderData"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, "订单状态异常，请刷新重新查询订单状态"))
    ])
  ], 64))
}
}

})